import { Component, OnInit, OnDestroy } from '@angular/core';

import { Observable, Subscription } from 'rxjs';

import {
  StudentRoleSettings,
  DelegatedTeam,
  CoupledEmployee,
  UserLevelEnum,
} from 'src/app/auth/models/UserData';
import { Label } from 'src/app/shared/framework/labels/models/Label';
import { AuthService } from 'src/app/auth/services/auth.service';
import { LoginService } from 'src/app/modules/authentication/login-pages/services/login.service';
import { LabelService } from 'src/app/shared/framework/labels/services/label.service';
import { EmployeeService } from 'src/app/shared/personnel-files/services/employee.service';
import { Student } from 'src/app/modules/lms/learningpaths/models/interfaces';

@Component({
  selector: 'app-role-dropdown',
  templateUrl: './role-dropdown.component.html',
  styleUrls: ['./role-dropdown.component.scss'],
})
export class RoleDropdownComponent implements OnInit, OnDestroy {
  public currentStudent: Student;
  public studentRoleSettings: StudentRoleSettings;
  public levels = UserLevelEnum;
  public defaultLevel: UserLevelEnum;
  public logoffLabel$: Observable<Label>;
  public name =
    'roles-' + Math.ceil(Math.random() * 10000) + '-' + new Date().getTime();
  public countroles: number;

  private subscriptions: Subscription[] = [];

  constructor(
    private _authService: AuthService,
    private _labelService: LabelService,
    private _employeeService: EmployeeService,
    private _loginService: LoginService
  ) { }

  ngOnInit() {
    this.getRoles();
    this.subscriptions.push(
      this._labelService.refreshPageNameInCache('general').subscribe((e) => {
        this.logoffLabel$ = this._labelService.getLabel(
          'logoff',
          'general',
          false
        );
      })
    );
  }

  getRoles() {
    this.studentRoleSettings = undefined;
    this.subscriptions.push(this._employeeService.getCurrentEmployee().subscribe(e => {
      this.currentStudent = e;

      this.subscriptions.push(
        this._authService.getUserRoles(true).subscribe((e) => {
          this.studentRoleSettings = e;
          switch (e.defaultLevel) {
            case 3:
              this.defaultLevel = UserLevelEnum.Employee;
              break;
            case 33:
              if (e.isManager) {
                this.defaultLevel = UserLevelEnum.Manager;
              } else if (e.isMatrixManager) {
                this.defaultLevel = UserLevelEnum.MatrixManager;
              }
              break;
            case 6:
              this.defaultLevel = UserLevelEnum.Trainer;
              break;
            case 1:
              this.defaultLevel = UserLevelEnum.CorporateHr;
              break;
            case 2:
              this.defaultLevel = UserLevelEnum.LocalHr;
              break;
            case 333:
              //We don't show the MatrixManager role when a user has a manager role.
              //Therefore this will have no radio button, so we use the manager radio button instead.
              if (e.isManager) {
                this.defaultLevel = UserLevelEnum.Manager;
              } else {
                this.defaultLevel = UserLevelEnum.MatrixManager;
              }
              break;
            default:
              break;
          }

          var countroles = 0;
          if (e.corporateHrId !== null) countroles += 1;
          if (e.localHrId !== null) countroles += 1;
          if (e.isManager) countroles += 1;
          if (e.delegatedTeams && e.delegatedTeams.length > 0)
            countroles += e.delegatedTeams.length;
          if (e.coupledEmployees && e.coupledEmployees.length > 0)
            countroles += e.coupledEmployees.length;
          if (e.studentId !== null) countroles += 1;
          if (e.trainerId !== null) countroles += 1;
          if (e.isMatrixManager) countroles += 1;
          this.countroles = countroles;
        })
      );
    }));

  }

  ngOnDestroy() {
    for (const subscr of this.subscriptions) {
      subscr.unsubscribe();
    }
  }

  public logOff(): void {
    this._authService.logOff();
  }

  public changeToEmployee(): void {
    this._authService.changeToEmployee();
  }

  public changeToManager(): void {
    this._authService.changeToManager();
  }

  public changeToDelegate(team: DelegatedTeam): void {
    this._authService.changeToDelegate(team);
  }

  public changeToCoupledEmployee(coupledEmployee: CoupledEmployee, asManager?: boolean): void {
    this._authService.changeToCoupledEmployee(coupledEmployee, asManager);
  }

  public changeToLocalHr(): void {
    this._authService.changeToLocalHr();
  }

  public changeToCorporateHr(): void {
    this._authService.changeToCorporateHr();
  }

  public changeToTrainer(): void {
    this._authService.changeToTrainer();
  }

  public changeToMatrixManager(): void {
    this._authService.changeToMatrixManager();
  }

  public changeDefaultRole(event) {
    let newDefault = 3;

    switch (event) {
      case UserLevelEnum.Employee:
        newDefault = 3;
        break;
      case UserLevelEnum.Manager:
        newDefault = 33;
        break;
      case UserLevelEnum.Trainer:
        newDefault = 6;
        break;
      case UserLevelEnum.CorporateHr:
        newDefault = 1;
        break;
      case UserLevelEnum.LocalHr:
        newDefault = 2;
        break;
      case UserLevelEnum.MatrixManager:
        newDefault = 333;
        break;
      default:
        break;
    }
    this.defaultLevel = event;

    this.subscriptions.push(
      this._loginService.setDefaultRole(newDefault, true).subscribe(() => {
        this.subscriptions.push(this._authService.getUserRoles().subscribe());
      })
    );
  }
}
